import { render } from "./Result.vue?vue&type=template&id=534609fd&scoped=true&ts=true"
import script from "./Result.vue?vue&type=script&lang=ts"
export * from "./Result.vue?vue&type=script&lang=ts"

import "./Result.vue?vue&type=style&index=0&id=534609fd&scoped=true&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534609fd"]])

export default __exports__